import { useRef, useEffect, useCallback } from "react";

export function useIdleTimers({
                                  cartItems,
                                  cartCreatedAtRef,
                                  cartIdRef,
                                  analytics,
                                  navigateToView,
                                  setIsIdle,
                                  setHistory,
                                  setCurrentStep,
                                  setCartItems
                              }) {
    const lastInteractionTimeRef = useRef(Date.now());
    const intervalRef = useRef(null);
    const stage1TriggeredRef = useRef(false);
    const idleStartedRef = useRef(false);
    const idleStartTimeRef = useRef(null); // <-- NUOVO: timestamp di inizio idle

    const IDLE_TIMEOUT_STAGE_1 = 3 * 60 * 1000;  // 3 minuti
    const IDLE_TIMEOUT_STAGE_2 = 23 * 60 * 1000; // 23 minuti (resta come avevi)

    const handleInteraction = useCallback(() => {
        const now = Date.now();

        // Se l’utente era in idle → termina idle
        if (idleStartedRef.current) {
            // Usiamo il momento di inizio idle, fallback a lastInteraction se manca
            const idleStart = idleStartTimeRef.current ?? lastInteractionTimeRef.current;
            const idleDuration = Math.round((now - idleStart) / 1000);

            analytics.trackIdleEnd(idleDuration);
            analytics.sessionStart();

            idleStartedRef.current = false;
            idleStartTimeRef.current = null;
        }

        lastInteractionTimeRef.current = now;
        stage1TriggeredRef.current = false;
        setIsIdle(false);
    }, [analytics, setIsIdle]);

    useEffect(() => {
        window.addEventListener("click", handleInteraction);
        window.addEventListener("keydown", handleInteraction);

        intervalRef.current = setInterval(() => {
            const now = Date.now();
            const timeSinceLastInteraction = now - lastInteractionTimeRef.current;

            // ----------- STAGE 2: idle completo (senza tracciamento idle) -----------
            if (timeSinceLastInteraction >= IDLE_TIMEOUT_STAGE_2) {
                setIsIdle(true);

                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                }
                return;
            }

            // ----------- STAGE 1: reset carrello + tracciamento idle_start -----------
            if (timeSinceLastInteraction >= IDLE_TIMEOUT_STAGE_1 && !stage1TriggeredRef.current) {
                stage1TriggeredRef.current = true;

                if (!idleStartedRef.current) {
                    idleStartedRef.current = true;
                    idleStartTimeRef.current = now; // <-- salviamo l’inizio dell’idle
                    analytics.trackIdleStart();
                    analytics.sessionEnd();
                }

                // Tracciamento abbandono carrello
                if (cartItems && cartItems.length > 0 && cartCreatedAtRef.current) {
                    const seconds = Math.round((now - cartCreatedAtRef.current) / 1000);
                    analytics.trackCart("cart_abandoned", {
                        cart_id: cartIdRef.current,
                        seconds_since_created: seconds
                    });
                    cartCreatedAtRef.current = null;
                }

                // Reset contenuto e navigazione
                setHistory([]);
                setCurrentStep(1);
                setCartItems([]);
                navigateToView("categories");
            }

        }, 1000);

        return () => {
            window.removeEventListener("click", handleInteraction);
            window.removeEventListener("keydown", handleInteraction);
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [
        handleInteraction,
        analytics,
        cartItems,
        cartCreatedAtRef,
        cartIdRef,
        navigateToView,
        setCartItems,
        setCurrentStep,
        setHistory,
        setIsIdle
    ]);
}
